import { render, staticRenderFns } from "./orderDetailNCustomer.vue?vue&type=template&id=37775243&scoped=true"
import script from "./orderDetailNCustomer.vue?vue&type=script&lang=js"
export * from "./orderDetailNCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37775243",
  null
  
)

export default component.exports